import { getUserData } from '../auth'

const UserService = {
    GetData: () => {
        return JSON.parse(getUserData())
    },
}

export default UserService